import maplibregl, { Map } from 'maplibre-gl'
import { useEffect } from 'react'
import { TDriverLocation } from '../../../services/rides/rides'

interface IProps {
  map?: Map
  ride: {
    id: number
    status: string
    start_lat: number
    start_lon: number
    destination_lat: number
    destination_lon: number
  } | null
  driver: TDriverLocation | null
}

export type TCenter = (coordinates: [number, number][], zoom: number) => void;

const Center = ({ map, ride, driver }: IProps) => {
  useEffect(() => {
    if (ride && map) {
      const coordinates: [number, number][] = [
        [ride.destination_lon, ride.destination_lat]
      ]
      if (ride.status !== 'in_progress') {
        coordinates.push([ride.start_lon, ride.start_lat])
      }
      if (driver) {
        coordinates.push([driver.lon, driver.lat])
      }

      center(coordinates, 12)
    }
  }, [ride?.id])
  const center: TCenter = (coordinates, zoom) => {
    if (!map) return
    const bounds = new maplibregl.LngLatBounds()

    coordinates.forEach(coordinate => {
      bounds.extend(coordinate)
    })
    map.fitBounds(bounds, {

      padding: {
        top: 200,
        left: 200,
        right: 50,
        bottom: 200
      },
      maxZoom: zoom,
      maxDuration: 2000
    })
  }
  return null
}

export default Center
